import { render, staticRenderFns } from "./BannerBroker.vue?vue&type=template&id=2f89a0d5&"
import script from "./BannerBroker.vue?vue&type=script&lang=js&"
export * from "./BannerBroker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports